import { Box, Button, Modal, Stack, Typography } from '@mui/material'
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useQueryClient } from 'react-query';
import CustomDropDown from '../../../components/CustomDropDown';
import { customAlert, notify } from '../../../components/notify';
import { useAuthContext } from '../../../context/AuthContext';
import { putBulkShipmtStatus } from '../../../services/shipmt-service';
import FillLabelTxtField from '../../../components/FillLabelTxtField';
import QueryKey from '../../../QueryKey';

const FAIL_REASON_MSGS = {
    invalidTransition: "Status change not allowed",
    paymentPending: "Customer Payment Pending",
    podMissing: "POD is required",
    ewbMissing: "Eway Bill B need to upload",
    checkError: "Something went wrong",
    updateFailed: "Update failed",
};

function BulkUpdateStatus({ modalOpen, handleModalClose, shipmtIds, trkOpReqId, onDone }) {

    const [formErrors, setFormErrors] = useState({});
    const { setLoadingScreen } = useAuthContext();
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    let txtFieldProps = { fontSize: 14, height: 38, width: 400 };
    const [selection, setSelection] = useState({ status: "" });

    const ddArr = [
        { value: "pending", label: t("bo.updSts.pending") },
        { value: "confirm", label: t("bo.updSts.confirm") },
        { value: "transportation", label: t("bo.updSts.transportation") },
        { value: "awaitingUnloading", label: t("bo.updSts.awaitingUnloading") },
        { value: "unloaded", label: t("bo.updSts.unloaded") },
        { value: "completed", label: t("bo.updSts.completed") },
        { value: "cancel", label: t("bo.updSts.cancel") }];

    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData);
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);

        if (Object.keys(errorsObj).length > 0)
            return;

        setLoadingScreen(true);
        try {
            const res = await putBulkShipmtStatus({
                shipmtIds, currStatus: inputObject?.status, cancelRemarks: inputObject?.cancelRemarks
            });

            if (res?.updated > 0)
                notify("success", `${res.updated} shipment(s) updated successfully`);

            (res?.results || []).filter(r => !r.success).forEach(r =>
                notify("error", `${r.shipmtId}: ${FAIL_REASON_MSGS[r.reason] || "Update failed"}`));

            handleModalClose();
            if (onDone) onDone();
            queryClient.invalidateQueries([QueryKey.singleTrkOpReq, trkOpReqId]);
        } catch (err) {
            customAlert(err);
        }
        setLoadingScreen(false)
    }

    function handlSelChange(e) {
        const { name, value } = e.target;
        setSelection(prevSel => { return { ...prevSel, [name]: value } })
    }

    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <form onSubmit={handleSubmit} >
                <Box sx={modalStyle}>
                    <Stack direction={'row'} alignItems={"center"} mb={3}>
                        <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)", mr: 1 }}>{t("bo.updSts.updSts")}</Typography>
                        <Typography sx={{ fontWeight: "bold", fontSize: 16, color: "rgba(0, 0, 0, 0.3)" }}>({shipmtIds?.length} {t("bo.trkOpReqInfoPg.shipmtsSel")})</Typography>
                    </Stack>
                    <Stack gap={2} alignItems="center">
                        <CustomDropDown handleDDChange={handlSelChange} title={t("bo.updSts.sts")} name={"status"} errMsg={formErrors.status} ddArr={ddArr} width={400} />
                        {selection.status === "cancel" && <FillLabelTxtField name="cancelRemarks" errMsg={formErrors.cancelRemarks} title={"Cancel Remark:"} {...txtFieldProps} multiline={true} height={103} />}
                        <Stack justifyContent={"flex-end"} direction={"row"} sx={{ mt: 2 }} width={400}>
                            <Button variant="text" sx={{ height: 40, width: 120 }} onClick={handleModalClose}>{t("bo.updSts.cancel")}</Button>
                            <Button variant="contained" type='submit' sx={{ height: 40, width: 150 }}>{t("bo.updSts.save")}</Button>
                        </Stack>
                    </Stack>
                </Box>
            </form>
        </Modal>
    )
}

export default BulkUpdateStatus;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 470,
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 4,
    py: 3,
    borderRadius: 2,
};

function validate(values) {
    const errors = {};

    if (!values.status)
        errors.status = "Status is required!";

    return errors;
};
